// #2802 / #2749 — "is this family renewing, and for which year?" for the STAFF
// surfaces: the Applications queue row, the committee meeting chip and the
// committee package list. The twin of backend/src/helpers/renewalCycle.js
// `renewalMark`; the server applies the same rule to the queue's Type filter
// and to the rows it computes the mark for (meeting rows, package rows).
//
// A family renews two ways. The in-app /renew flow writes `kind: 'renewal'`.
// A family with no platform account or grant (every renewal family on
// 2026-10-18) applies through /apply: its record is `kind: 'initial'` and only
// `intake.application_type` ('renewal_year_2' | 'renewal_year_3') says it is
// renewing. `kind` still decides LIFECYCLE (an approved in-app renewal makes a
// grant request; an /apply renewal is admitted like a new family) — this rule
// is for naming and filtering only.
//
// Staff surfaces are English by design; the family-facing year descriptor is
// `renewalYearMsgFromApp` in renewal-display.ts.
import { renewalYearNumber } from './renewal-display';

export interface RenewalMark {
  /** 2 or 3; null for an in-app renewal whose record names no year. */
  year: 2 | 3 | null;
}

interface RenewalMarkSource {
  kind?: string | null;
  intake?: unknown;
  /** A list row's server-computed mark (`renewalMark`), when the server sent one. */
  renewal?: RenewalMark | null;
}

/** The family's renewal mark, or null when it is not renewing. */
export function renewalMarkOf(app: RenewalMarkSource | null | undefined): RenewalMark | null {
  if (!app) return null;
  if (app.renewal !== undefined) return app.renewal;
  const intake = app.intake as Record<string, unknown> | null | undefined;
  const year = renewalYearNumber(intake?.application_type);
  if (year !== null || app.kind === 'renewal') return { year };
  return null;
}

/** "Renewal · Year 2", "Renewal" with no year, or null for no mark. */
export function renewalMarkLabel(mark: RenewalMark | null | undefined): string | null {
  if (!mark) return null;
  return mark.year ? `Renewal · Year ${mark.year}` : 'Renewal';
}
